// watch-cart.js
//
// Added on May 14th by jeff@jeffthistle.com to facilitate a My Chemical Romance upsell promotion. If any of the
// 'targetVariants' variant ids are added to the cart, a one-time popup is displayed offering to push 'offerVariant'
// to the cart. 

// const targetVariants = [ 48128702775555 , 48128702808323 , 48128702841091 , 48128702873859 , 48128702906627 , 48128702939395 , 48128700547331 , 48128700580099 , 48128700612867 , 48128700645635 , 48128700678403 , 48128700711171 , 48128704872707 , 48128704905475 , 48128704938243 , 48128704971011 , 48128705003779 , 48128705036547 , 48128710115587 , 48128710148355 , 48128710181123 , 48128710213891 , 48128710246659 , 48128710279427 , 48129553989891 , 48129554022659 , 48129554055427 , 48129554088195 , 48129554120963 , 48129554153731 , 48129595998467 , 48129596031235 , 48129596064003 , 48129596096771 , 48129596129539 , 48129604616451 , 48129604649219 , 48129604681987 , 48129604714755 , 48129604747523 , 48129605730563 , 48129345782019 , 48129345814787 , 48129345847555 , 48129345880323 , 48129345913091 , 48129345945859 , 48129608614147 , 48129608646915 , 48129608679683 , 48129608712451 , 48129608745219 , 48129608777987 , 48129668251907 , 48129670414595 , 48129668251907 , 48129673560323 , 48129673855235 , 48129674117379 ];
// const offerVariant = 48128642646275;
const targetVariants = [  48128702775555 , 48128702808323 , 48128702841091 , 48128702873859 , 48128702906627 , 48128702939395 , 48128700547331 , 48128700580099 , 48128700612867 , 48128700645635 , 48128700678403 , 48128700711171 , 48128704872707 , 48128704905475 , 48128704938243 , 48128704971011 , 48128705003779 , 48128705036547 , 48128710115587 , 48128710148355 , 48128710181123 , 48128710213891 , 48128710246659 , 48128710279427 , 48129553989891 , 48129554022659 , 48129554055427 , 48129554088195 , 48129554120963 , 48129554153731 , 48129595998467 , 48129596031235 , 48129596064003 , 48129596096771 , 48129596129539 , 48129604616451 , 48129604649219 , 48129604681987 , 48129604714755 , 48129604747523 , 48129605730563 , 48129345782019 , 48129345814787 , 48129345847555 , 48129345880323 , 48129345913091 , 48129345945859 , 48129608614147 , 48129608646915 , 48129608679683 , 48129608712451 , 48129608745219 , 48129608777987 , 48129668251907 , 48129670414595 , 48129668251907 , 48129673560323 , 48129673855235 , 48129674117379 ];   
const offerVariant = 48128642646275;

// Catch the add click
const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  const url = args[0].toString();

  // If the URL is one of Shopify's cart endpoints
  if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {    
    // Wait for the theme's own JS to finish, then fetch fresh cart state
    setTimeout(async () => {
      const freshRes = await originalFetch('/cart.js');
      const freshCart = await freshRes.json();
      checkCartForUpsell(freshCart);
    }, 1200); 
  }

  return response;
};

async function checkCartForUpsell(cart) {  

  if (!cart || !cart.items) return;
 
  if (sessionStorage.getItem('upsell_shown') === 'true') return;

  // Check the items already present in the cart object
  const found = cart.items.some(item => targetVariants.includes(item.variant_id));
  if (!found) return;
  
  // Store that we've seen it
  sessionStorage.setItem('upsell_shown', 'true');

  // Try to find the message element, or create it if it doesn't exist
  let messageElement = document.getElementById('custom-upsell-message');

  if (!messageElement) {
    messageElement = document.createElement('div');
    messageElement.id = 'custom-upsell-message';
    
    // Initial Styles - You can move these to your CSS file instead
    Object.assign(messageElement.style, {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)', // This perfectly centers the element
      zIndex: '2147483647',
      padding: '30px',
      backgroundColor: '#ffffff',
      color: '#333333',
      textAlign: 'center',
      borderRadius: '12px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
      width: '90%',
      maxWidth: '400px',
      border: '1px solid #ddd',
      display: 'none'
    });

    messageElement.innerHTML = `
      <button id="close-upsell-x" style="
        position: absolute;
        top: 10px;
        right: 10px;
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        color: #999;
        line-height: 1;
        padding: 5px;
      ">&times;</button>
      <h3 style="margin: 0 0 10px 0; font-size: 20px;">GET 20% OFF</h3>
      <h3 style="margin: 0 0 10px 0; font-size: 20px;">Danger Days (Deluxe Edition) 2CD</h3>
      <img src="https://cdn.shopify.com/s/files/1/0784/1125/files/DD15_CD-Retail_1.png?v=1778769122" style="width: 200px;">
      <p style="margin-top: 8px; margin-bottom: 20px; color: #666; line-height: 1.5;">When you add it now</p>
      <button id="upsell-add-to-cart" style="
        background: #000;
        color: #fff;
        border: none;
        padding: 12px 24px;
        border-radius: 6px;
        cursor: pointer;
        width: 100%;
        font-weight: bold;
      ">Add To Cart</button>
    `;
    
    document.body.appendChild(messageElement);

    // Function to hide the message
    const hideMessage = () => {
      messageElement.style.display = 'none';
      // Optional: Add a class to prevent it from re-opening during this session
      messageElement.dataset.dismissed = 'true';
    };

    const addUpsellOffer = async () => {
        const formData = {
            'items': [{
            'id': offerVariant,
            'quantity': 1
            }]
        };

        try {
            const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
            });

            const data = await response.json();
            

            // // Trigger a refresh of the cart UI so the user sees the change
            // document.dispatchEvent(new CustomEvent('cart:updated', {
            // detail: { cart: data }
            // }));

            location.reload();
        } catch (error) {
            console.error('Error adding to cart:', error);
        }
    };

    // Attach listeners to both the X and the main button
    document.getElementById('close-upsell-x').addEventListener('click', hideMessage);
    document.getElementById('upsell-add-to-cart').addEventListener('click', addUpsellOffer);
  }

    messageElement.style.display = 'block';

}